import api from "@/utils/axios";
import { GAZETTE_ROLES } from "@/main"; // import the global roles array

export const loginUser = async (payload) => {
    try {
        const response = await api.post("/api/auth/login", payload);

        const user = response.data.raw;
        const token = response.data.token;

        if (!token || !user) {
            throw new Error("Invalid credentials");
        }

        // Only allow users in the global GAZETTE_ROLES
        if (!GAZETTE_ROLES.includes(user.gazetteRole)) {
            const err = new Error("Unauthorized: You do not have access to the CMS.");
            err.code = 403;
            throw err;
        }

        // Allowed → return both token and user
        return { token, user };
    } catch (err) {
        console.error("Login API error:", err.response || err);
        throw err;
    }
};